import React from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";

const License: React.FC = () => {
  return (
    <div className="d-flex flex-column mb-5" style={{ height: '100%', backgroundColor: '#f8f6f0' }}>
      <ScrollToTop />

      {/* Breadcrumb */}
      <div className="py-3">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0 font_two">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none active text-dark ">
                  Home
                </Link>
              </li>
              <li
                className="breadcrumb-item fw_700 font-medium"
                aria-current="page"
              >
                License & Usage
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container flex-grow-1 d-flex flex-column flex-lg-row py-4">
        {/* Left Content */}
        <div className="col-lg-4 mb-4 mb-lg-0">
          <h1 className="mb-3" style={{ fontSize: '2.5rem', fontWeight: '500', color: '#2c3e50', fontFamily: 'Lora' }}>
            License & Usage
          </h1>
          <p className="text-muted mb-0 font-satoshi" style={{ fontSize: '1.1rem', lineHeight: '1.6', fontFamily: 'Satoshi, sans-serif' }}>
            We are committed to providing high-quality digital artworks while ensuring a safe, transparent, and fair experience for all our users.
          </p>
        </div>

        {/* Vertical Divider */}
        <div className="d-none d-lg-block" style={{
          padding: '0.5px',
          backgroundColor: '#112C3B4D',
          margin: '0 2rem',
          alignSelf: 'stretch'
        }}>
        </div>

        <div>
          <hr className="mt-0" />
        </div>

        {/* Right Content */}
        <div className="col-lg-8">
          <div className="license-content" style={{ lineHeight: '1.7', fontFamily: 'Satoshi, sans-serif' }}>
            <p className="mb-4" style={{ fontSize: '1rem', color: '#555' }}>
              At DigiCartt, we aim to create a reliable and enjoyable environment for art lovers and collectors.
              Our platform offers digital artworks that can be instantly downloaded after purchase. We strive to
              maintain accuracy in product descriptions, images, and file details to help you make informed choices.
            </p>

            <p className="mb-4" style={{ fontSize: '1rem', color: '#555' }}>
              We are dedicated to maintaining transparency in our pricing, licensing, and service offerings.
              All artworks on our website are protected by copyright laws, and ownership rights remain with the
              respective artists. Customers are expected to use the purchased files responsibly and in accordance
              with the Terms of Service.
            </p>

            <p className="mb-0" style={{ fontSize: '1rem', color: '#555' }}>
              Our general policy ensures fair treatment for all users, timely customer support, and continuous
              improvements to enhance your browsing and shopping experience. We may update this policy as needed
              to keep up with technological, legal, or business changes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default License;
